import { useIntl } from 'react-intl';

import classNames from 'classnames';

import CheckIcon from '@/material-icons/400-24px/check.svg?react';
import CelebrationIcon from '@/material-icons/400-24px/celebration.svg?react';
import { Icon } from 'flavours/glitch/components/icon';
import type { Account } from 'flavours/glitch/models/account';

import { EmojiHTML } from './emoji/html';
import { useElementHandledLink } from './status/handled_link';

var balloonsSpawned = 0;

function BalloonCheck(field) {
  const parsed_date = Date.parse(field.value);
  if(Number.isNaN(parsed_date)) {
    return;
  }
  const field_date = new Date(parsed_date);
  const today = new Date();

  if(field_date.getMonth() == today.getMonth() && field_date.getDate() == today.getDate()) {
    const colors = ["b", "g", "m", "o", "p", "r"];
    var spans = []
    for(var i = 0; i < 35 && balloonsSpawned < 100; i++, balloonsSpawned++) {
      const color = `balloon-${colors[Math.floor(Math.random() * 6)]}`;
      const top = Math.floor(Math.random() * (180 - 110 + 1) + 110);
      const left = Math.floor(Math.random() * (95 - -3 + 1) + -3);
      const speed = Math.floor(Math.random() * (300 - 200 + 1) + 200);
      const style = {top: `${top}%`, left: `${left}%`, "--new-top": `${top - speed}%`} as React.CSSProperties;
      spans.push(
        (
          <span className={color} style={style}></span>
        )
      );
    }
    return (
      <span title='🎉'>
        <Icon id='celebration' icon={CelebrationIcon} className='verified__mark' />
        {spans}
      </span>
    )
  }

  // just to return something from all paths, I guess?
  return (
    <span></span>
  )
}

export const AccountFields: React.FC<Pick<Account, 'fields' | 'emojis'>> = ({
  fields,
  emojis,
}) => {
  const intl = useIntl();
  const htmlHandlers = useElementHandledLink();

  if (fields.size === 0) {
    return null;
  }

  balloonsSpawned = 0;

  return (
    <>
      {fields.map((pair, i) => (
        <dl key={i} className={classNames({ verified: pair.verified_at })}>
          <EmojiHTML
            as='dt'
            htmlString={pair.name_emojified}
            extraEmojis={emojis}
            className='translate'
            {...htmlHandlers}
          />

          <dd className='translate' title={pair.value_plain ?? ''}>
            {pair.verified_at && (
              <span
                title={intl.formatMessage(
                  {
                    id: 'account.link_verified_on',
                    defaultMessage:
                      'Ownership of this link was checked on {date}',
                  },
                  {
                    date: intl.formatDate(pair.verified_at, dateFormatOptions),
                  },
                )}
              >
                <Icon id='check' icon={CheckIcon} className='verified__mark' />
              </span>
            )}{' '}{BalloonCheck(pair)}
            <EmojiHTML
              as='span'
              htmlString={pair.value_emojified}
              extraEmojis={emojis}
              {...htmlHandlers}
            />
          </dd>
        </dl>
      ))}
    </>
  );
};

const dateFormatOptions: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};
